import { ApiError } from './api';

/** O texto que a tela mostra quando o painel recusa: a mensagem da API, ou o 401 que leva ao login. */
export class ApiFailure {
  static messageOf(err: unknown, onUnauthorized: () => void): string {
    if (err instanceof ApiError && err.status === 401) {
      onUnauthorized();
      return 'Sessão do painel expirada';
    }
    const body = err instanceof ApiError ? (err.body as { message?: string } | null) : null;
    return body?.message ?? (err instanceof Error ? err.message : 'Erro ao falar com o painel');
  }
}
